import { MenuItem } from '../types/media-preview';
import { AcrScanStatus } from '../types/acr';
import { getDetailLabelWithAcr } from './acr';

export interface AudioMenuOptions {
  onPreview?: () => void;
  onDetailInfo: () => void;
  onDownload: () => void;
  /** 指定時のみ「文字起こし」を表示する（fileId があるメディアのみ） */
  onTranscribe?: () => void;
  acrScanStatus?: AcrScanStatus;
}

/**
 * オーディオファイルの三点リーダーメニュー項目を構築する。
 * メッセージ内コンパクト表示・フォルダモーダル共通。
 */
export function buildAudioMenuItems(options: AudioMenuOptions): MenuItem[] {
  const { onPreview, onDetailInfo, onDownload, onTranscribe, acrScanStatus } = options;
  const items: MenuItem[] = [];

  if (onPreview) {
    items.push({ label: 'プレビュー', onClick: onPreview });
  }

  const detailItem = getDetailLabelWithAcr(acrScanStatus);
  items.push({ label: detailItem.label, color: detailItem.color, onClick: onDetailInfo });

  items.push({ label: 'ダウンロード', onClick: onDownload });

  if (onTranscribe) {
    items.push({ label: '文字起こし', onClick: onTranscribe });
  }

  return items;
}
